import { TableColumnMeta } from "ds/components/Table/types";

export enum CONTEXTS_COLUMN_ID {
  NAME = "NAME",
  LABELS = "LABELS",
  SPACE = "SPACE",
  CREATED_AT = "CREATED_AT",
  DESCRIPTION = "DESCRIPTION",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const CONTEXTS_COLUMNS_STORAGE_KEY = "contextsColumnsConfig";

export const CONTEXTS_COLUMN_CONFIG: Record<CONTEXTS_COLUMN_ID, TableColumnMeta> = {
  [CONTEXTS_COLUMN_ID.NAME]: {
    id: CONTEXTS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [CONTEXTS_COLUMN_ID.DESCRIPTION]: {
    id: CONTEXTS_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 130,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [CONTEXTS_COLUMN_ID.LABELS]: {
    id: CONTEXTS_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 100,
    defaultWidth: 140,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [CONTEXTS_COLUMN_ID.SPACE]: {
    id: CONTEXTS_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [CONTEXTS_COLUMN_ID.CREATED_AT]: {
    id: CONTEXTS_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 145,
    defaultWidth: 160,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [CONTEXTS_COLUMN_ID.DROPDOWN]: {
    id: CONTEXTS_COLUMN_ID.DROPDOWN,
    title: "Context actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const CONTEXTS_SORT_CONFIG: Record<string, string> = {
  [CONTEXTS_COLUMN_ID.NAME]: "name",
  [CONTEXTS_COLUMN_ID.CREATED_AT]: "createdAt",
  [CONTEXTS_COLUMN_ID.SPACE]: "space",
};
